import HomeAlertDetail from "@/components/HomeMain/AlertDetail";

export default function AlertDetail() {
  return <HomeAlertDetail />;
}
